import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.banner',
            autoLoadBannersHome: true,
            banners: [],
            forms: {
                'home.main': {
                    component: 'default-banners-form',
                    alias: 'Home - Principal',
                    tableImage: 'images.small'
                }
            }
        }
    },

    methods: {
        getHomeBanners() {
            axios({
                method: 'get',
                url: route('api.banners.index'),
                params: {
                    scopes: {whereType: 'home.main'},
                    paginate: 10
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'banners', response.data.data.data)
                }
            })
        },

        addForm(type, component, alias, tableImage = 'images.small') {
            this.forms[type] = {
                component: component,
                alias: alias,
                tableImage: tableImage
            }

            return this
        },

        getForm(type) {
            return this.forms[type] ?? {}
        }
    },

    created() {
        if(
            this.autoLoadBannersHome &&
            this.$state.scope == 'web'
        ) {
            this.getHomeBanners()
        }
    }
}